<section class="summary-data-table-component">
  <div class="row py-3 mx-0">
    <!-- View For / Any other dropdown select section -->
    <div class="col-12 col-md-4 px-0">
      <div class="content-selector-panel" *ngIf="options.contentSelector">
        {{ data.contentSelector.label }} &nbsp;&nbsp;
        <select [value]="data.contentSelector?.selectedValue" (change)="data.contentSelector.onChange($event)">
          <option
            *ngFor="let option of data.contentSelector?.selectionOptions"
            [value]="option.key"
            [selected]="option.key == data.contentSelector?.selectedValue"
          >
            {{ option.value }}
          </option>
        </select>
      </div>
    </div>

    <!-- Download / Export Buttons Section -->
    <div class="col-12 col-md-8 px-0 text-md-end download-options">
      <a class="download-as-label" *ngIf="options.downloadable">Download as</a>
      <a
        (click)="data.downloadDocumentCallback('CSV')"
        class="download-button"
        *ngIf="options.downloadable"
        ><img src="assets/images/svg/xls.svg" />&nbsp; CSV</a
      >
      <a
        (click)="data.downloadDocumentCallback('XLSX')"
        class="download-button"
        *ngIf="options.downloadable"
        ><img src="assets/images/svg/xls.svg" />&nbsp; XLS</a
      >
      <a
        (click)="data.downloadDocumentCallback('PDF')"
        class="download-button"
        *ngIf="options.downloadable"
        ><img src="assets/images/svg/pdf.svg" />&nbsp; PDF</a
      >
      <span *ngIf="options.additionalButtons">
        <a
          class="additional-button"
          *ngFor="let button of data.additionalButtons"
          [routerLink]="button.route"
          [id]="button.id"
        >
          {{ button.label }}
        </a>
      </span>
    </div>
  </div>

  <!-- Data Table Section -->
  <div class="summary-table col-12">
    <form
      [formGroup]="summarySearchForm"
      (submit)="searchFormSubmit()"
      (keyup.enter)="searchFormSubmit()"
      (change)="searchFormSubmit()"
    >
      <table
        class="table table-striped table-bordered table-sm row-border hover"
        *ngIf="data.content$ | async as dataRecords"
      >
        <thead>
          <tr class="column-header-row">
            <th *ngIf="options.contentSelectable" style="width: 40px" class="selection-cell"></th>
            <th *ngFor="let header of data.headers">
              {{ header.name }}<br />
              <div class="sort-icons" *ngIf="header.sortByKey">
                <a
                  [ngClass]="
                    data.currentSearchParams.sortBy == header.key && data.currentSearchParams.sortOrder == 'ASC'
                      ? 'selected'
                      : ''
                  "
                  (click)="data.sortCallback(header.sortByKey, 'ASC')"
                >
                  <i class="fa fa-caret-down"></i>
                </a>
                <a
                  [ngClass]="
                    data.currentSearchParams.sortBy == header.key && data.currentSearchParams.sortOrder == 'DESC'
                      ? 'selected'
                      : ''
                  "
                  (click)="data.sortCallback(header.sortByKey, 'DESC')"
                >
                  <i class="fa fa-caret-up"></i>
                </a>
              </div>
            </th>
          </tr>
          <tr>
            <th *ngIf="options.contentSelectable">
              <input
                type="checkbox"
                name="select-all"
                id="select-all"
                value=""
                (click)="toggleSelectAll($event, dataRecords.content)"
              />
            </th>

            <!-- Search Filter Input Elements Row -->
            <th *ngFor="let header of data.headers">
              <div *ngIf="header.filter">
                <input
                  *ngIf="header.filter.type == FieldType.TEXT"
                  type="text"
                  class="search_text"
                  id="search_{{ header.filter.key }}"
                  [formControlName]="header.filter.key"
                />
                <select
                  *ngIf="header.filter.type == FieldType.SELECT_TASK_STATUS"
                  class="search_text"
                  id="search_{{ header.filter.key }}"
                  [formControlName]="header.filter.key"
                >
                  <option></option>
                  <option *ngFor="let option of header?.filter?.getOptionsList() | keyvalue" [value]="option.key">
                    {{ option.value }}
                  </option>
                </select>
                <select
                  *ngIf="header.filter.type == FieldType.SELECT"
                  class="search_text"
                  id="search_{{ header.filter.key }}"
                  [formControlName]="header.filter.key"
                >
                  <option></option>
                  <option
                    *ngFor="let option of header.filter?.getOptionsList('ACTIVITY') | keyvalue"
                    [value]="option.key"
                  >
                    {{ option.value }}
                  </option>
                </select>
                <input
                  *ngIf="header.filter.type == FieldType.DATE"
                  type="date"
                  class="form-control"
                  onFocus="this.showPicker()"
                  [formControlName]="header.filter.key"
                />
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr [class]="data.rowFormatting && data.rowFormatting(record)" *ngFor="let record of dataRecords.content">
            <td *ngIf="options.contentSelectable" style="width: 40px" class="selection-cell">
              <input
                type="checkbox"
                [name]="record['id']"
                [checked]="data.checkBoxSelectionIds?.indexOf(record.id) >= 0"
                (click)="onCheckBoxChecked($event, record)"
              />
            </td>
            <td *ngFor="let header of data.headers" [classList]="header.cssClasses ? header.cssClasses : ''">
              <a *ngIf="header.anchor" [routerLink]="header.anchor.link(record)">
                {{ header.build(record) }}
              </a>
              <span *ngIf="!header.anchor">
                {{ header.build(record) }}
              </span>
            </td>
          </tr>
          <tr *ngIf="dataRecords?.totalElements === 0">
            <td class="no-rows-to-display" [attr.colspan]="100">No Records Found</td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
  <div class="col-12 pagination" *ngIf="data.content$ | async as dataRecords">
    <div *ngIf="this.data?.onDropdownLimitChange" class="col-1 limit-dropdown-container">
      <select [value]="selectedLimitDropdownValue" (change)="onLimitValueChange($event?.target?.value)">
        <option
          *ngFor="let limit of limitDropdownValues"
          [value]="limit"
          [selected]="limit == selectedLimitDropdownValue"
        >
          {{ limit }}
        </option>
      </select>
    </div>
    <div class="col-6 showing">
      Showing {{ dataRecords.size * dataRecords.number + 1 }} to
      {{
        dataRecords.number == dataRecords.totalPages - 1
          ? dataRecords.totalElements
          : dataRecords.size * (dataRecords.number + 1)
      }}
      of {{ dataRecords.totalElements }} records
    </div>
    <div class="col-6">
      <ul class="col-12 text-md-end">
        <li *ngIf="dataRecords.number != 0">
          <div class="inverse" (click)="data.selectPageCallback(dataRecords.number - 1)">
            <i class="fas fa-angle-left"></i>
          </div>
        </li>

        <ng-container *ngFor="let page of [].constructor(dataRecords.totalPages); let i = index">
          <li *ngIf="!(i > dataRecords.number + 5) && !(i < dataRecords.number - 5)">
            <div [class]="dataRecords.number == i ? 'selected' : ''" (click)="data.selectPageCallback(i)">
              {{ i + 1 }}
            </div>
          </li>
        </ng-container>

        <li *ngIf="dataRecords.number != dataRecords.totalPages - 1">
          <div class="inverse" (click)="data.selectPageCallback(dataRecords.number + 1)">
            <i class="fas fa-angle-right"></i>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="col-12 formatting-legend">
    <div>
      <ul>
        <li *ngFor="let formatting of data.formattingLegend">
          <div [class]="formatting.formatClassName"></div>
          {{ formatting.formatLabel }}
        </li>
      </ul>
    </div>
  </div>
</section>
